module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-sv.95a9e8cd75ad16594d36.svg";